import { createContext, useContext } from 'react';

import veterinaroOnDark from 'assets/img/partners/veterinaro-logo-on-dark.png';
import veterinaroOnLight from 'assets/img/partners/veterinaro-logo-on-light.png';

// Variants of the landing page; texts live in i18n under page.<id>
export const PAGES = {
  home: {
    id: 'home',
    path: '/',
    modal: 'demo'
  },
  veterinaro: {
    id: 'veterinaro',
    path: '/veterinaro',
    modal: 'veterinaro',
    partner: { name: 'Veterinaro', logoOnDark: veterinaroOnDark, logoOnLight: veterinaroOnLight },
    social: true,
    raisedTranscript: true
  }
};

export const PageContext = createContext(PAGES.home);

export const usePage = () => useContext(PageContext);
